import { useTranslation } from 'react-i18next';
import type { CommitResult } from '../../lib/import-api.js';

// Abschluss-Schritt des Import-Wizards. #125: beim Neuimport ist „angelegt" nur ein Teil — der
// Admin sieht hier auch, was aktualisiert, auf „Reifegrad: nicht im Scope" gesetzt oder gelöscht
// wurde, und vor allem, was NICHT geschah (unvollständige neue Ketten, zurückgehaltene Testfälle,
// Kettenglieder ohne Testfall). Nichts davon soll nur im Audit-Log stehen.
export function CommitSummary({ result }: { result: CommitResult }) {
  const { t } = useTranslation();
  if (result.mode !== 'reimport') {
    return (
      <p className="text-sm text-status-pass">
        {t('import.done.summary', {
          testCases: result.test_cases,
          processes: result.processes,
          e2e: result.e2e,
        })}
      </p>
    );
  }
  return (
    <div className="flex flex-col gap-2">
      <p className="text-sm text-status-pass">
        {t('import.done.summaryReimport', {
          created: result.test_cases,
          updated: result.updated,
          dropped: result.dropped,
          deleted: result.deleted,
        })}
      </p>
      <p className="text-xs text-text-body">
        {t('import.done.chainsReimport', {
          created: result.e2e,
          updated: result.e2e_updated,
          processes: result.processes,
        })}
      </p>
      {result.unresolved_members > 0 && (
        <output className="block text-xs text-status-warn">
          {t('import.done.unresolvedMembers', { count: result.unresolved_members })}
        </output>
      )}
      {result.chains_skipped_incomplete.length > 0 && (
        <p className="text-xs text-status-warn">
          {t('import.done.chainsSkipped', {
            names: result.chains_skipped_incomplete.map((c) => c.name).join(', '),
          })}
        </p>
      )}
      {result.test_cases_held_back.length > 0 && (
        <p className="text-xs text-status-warn">
          {t('import.done.heldBack', {
            titles: result.test_cases_held_back.map((c) => c.title).join(', '),
          })}
        </p>
      )}
    </div>
  );
}
